import { render, staticRenderFns } from "./ProgramRichDescriptions.vue?vue&type=template&id=2dfdd90e&scoped=true&"
import script from "./ProgramRichDescriptions.vue?vue&type=script&lang=js&"
export * from "./ProgramRichDescriptions.vue?vue&type=script&lang=js&"
import style0 from "./ProgramRichDescriptions.vue?vue&type=style&index=0&id=2dfdd90e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfdd90e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow})
